const eth = [{
    coin: 'BTC/ETH',
    vlr: 0.00020255,
    color: 'red',
    updow: '-2.58%'
},
 {
    coin: 'ADA/ETH',
    vlr: 0.00050103,
    color: 'green',
    updow: '+5.05% '

}, {
    coin: '	NEO/ETH',
    vlr: 0.00340103,
    color: 'red',
    updow: '-1.05% '

}, {
    coin: 'XLM/ETH',
    vlr: 0.00035103,
    color: 'green',
    updow: '+5.05% '

}, {
    coin: 'ENQ/ETH',
    vlr: 0.00354103,
    color: 'green',
    updow: '+2.02%'
}, {
    coin: 'AVA/ETH',
    vlr: 0.02535103,
    color: 'green',
    updow: '+3.05% '

}, {
    coin: 'AMB/ETH',
    vlr: 0.05335103,
    color: 'green',
    updow: '+1.0%'

}, {
    coin: ' MAP/ETH',
    vlr: 0.00234103,
    color: 'red',
    updow: '-2.05% '

}, {
    coin: 'GO/ETH',
    vlr: 0.00354103,
    color: 'red',
    updow: '-6.50%'
}, {
    coin: 'KICK/ETH',
    vlr: 0.02053103,
    color: 'red',
    updow: '-6.05%'

}, {
    coin: 'DBC/ETH',
    vlr: 0.02535103,
    color: 'green',
    updow: '+7.05% '

}, {
    coin: '	GGC/ETH',
    vlr: 0.00353103,
    color: 'red',
    updow: '-4.05%'
},
]

export default eth